import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
// import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import AboutUs from "../components/AboutUs";

import "../styles/App.css";
import schoolImg from "../images/school_img_1.jpg";

// Import images
// import schoolImg1 from "../images/school_img_1.jpg";
// import schoolImg2 from "../images/school_img_2.jpg";
// import schoolImg3 from "../images/school_img_3.jpg";

// Import AdButton component
// import AdButton from "../components/AdButton";

const HomePage = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <Navbar />

      {/* Hero Section with Carousel */}
      <section
        className="relative bg-center bg-cover"
        style={{ backgroundImage: `url(${schoolImg})` }}
      >
        {/* Overlay for better contrast */}
        <div className="absolute inset-0 bg-gray-900 opacity-70"></div>

        {/* Content over the background */}
        <div className="relative z-10 flex items-center justify-center p-10 m-5 mx-auto mt-10 overflow-hidden shadow-2xl rounded-3xl max-w-7xl">
          <div className="w-full max-w-6xl px-4 sm:px-6">
            <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
              {/* Left Section: Text Content */}
              <div className="flex flex-col justify-center text-center md:text-left">
                <h1 className="text-4xl font-extrabold leading-tight tracking-tight text-white uppercase sm:text-4xl md:text-5xl lg:text-8xl">
                  Welcome to{" "}
                  <span className="text-yellow-500">Shinpex Academy</span>
                </h1>
                {/* <p className="mt-4 text-base font-medium text-gray-200 sm:text-lg md:text-xl">
                  Located in ilorin kwara state. frture the next
                </p> */}
                <div className="flex flex-wrap gap-4 mt-6">
                  <a
                    href="#mission"
                    className="p-3 text-sm font-bold tracking-widest text-center text-black uppercase transition bg-yellow-500 rounded-sm grow hover:bg-yellow-600"
                  >
                    Our Mission
                  </a>
                  <a
                    href="#vision"
                    className="p-3 text-sm font-bold tracking-widest text-center text-yellow-500 uppercase transition border border-yellow-500 rounded-sm grow hover:bg-yellow-500 hover:text-black"
                  >
                    Our Vision
                  </a>
                </div>
              </div>

              {/* Right Section: Visual Block */}
              <div className="relative flex items-center sm:m-10">
                <div className="absolute hidden bg-yellow-500 border-b-4 border-r-8 border-yellow-700 rounded-lg -top-10 md:-top-20 -left-10 sm:w-32 sm:h-32 lg:w-64 lg:h-64 rotate-12 sm:block"></div>
                <div className="relative z-10 p-4 text-center -translate-x-1/2 bg-gray-800 border-b-4 border-r-8 shadow-2xl sm:p-6 -right-1/2 grow -rotate-2 rounded-xl border-slate-950">
                  <h2 className="text-2xl font-bold uppercase sm:text-3xl text-gray-50">
                    Bold. Strong. Raw.
                  </h2>
                  <p className="mt-1 text-sm font-light text-gray-400 sm:text-base">
                    Embrace minimalism with maximal impact.
                  </p>
                </div>
                <div className="absolute hidden bg-yellow-500 border-b-8 border-r-4 border-yellow-700 rounded-lg -bottom-10 md:-bottom-20 -right-16 sm:w-32 sm:h-32 lg:w-64 lg:h-64 -rotate-12 sm:block"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="w-full overflow-hidden transition-all bg-white shadow-2xl">
        {/* Card Header */}
        {/* <div className="relative">
          <div className="flex items-center justify-center h-72 bg-gradient-to-r from-green-700 to-yellow-500">
            Gradient Overlay
            <div className="absolute inset-0 bg-black opacity-50"></div>
            <div className="relative z-10 flex flex-col items-center justify-center">
              <h2 className="text-3xl font-bold text-white">SHINPEX ACADEMY</h2>
              <p className="mt-2 text-xl text-white">The Hope Of Africa!</p>
            </div>
          </div>
        </div> */}
        {/* Card Body */}
        <div className="p-6 space-y-4">
          {/* <p className="text-lg leading-relaxed text-yellow-400">
            "The tide of Africa's brain drain must be reversed by creating a
            world-class education and research infrastructure."
          </p> */}
          <div>
            <AboutUs />
          </div>
          
        </div>
      </section>

      {/* Apply Now Button */}
      <div className="flex justify-center my-8">{/* <AdButton /> */}</div>

      <Footer />
    </div>
  );
};

export default HomePage;
